require("slick-carousel");

export default class SellMorePage {
  constructor() {
    this.featuresTabs = document.querySelectorAll(".features-toggle__item");
    this.featuresWrappers = document.querySelectorAll(
      ".features__items-wrapper"
    );
    this.featureSections = document.querySelectorAll(".features");
    this.headerOffset = 140;
  }

  init() {
    this.initFeaturesTabs();

    this.featuresWrappers.forEach((wrapper) => {
      this.initFeaturesSlider({
        carousel: wrapper.querySelector(".features__items"),
        prevBtn: wrapper.querySelector(".features__items-button-prev"),
        nextBtn: wrapper.querySelector(".features__items-button-next"),
      });
    });
  }

  initFeaturesTabs() {
    const featuresTabs = this.featuresTabs;
    const featureSections = this.featureSections;
    const headerOffset = this.headerOffset;

    const updateActiveTab = () => {
      const scrollPosition = window.pageYOffset;
      let activeSection = null;
      let closestTop = -Infinity;

      featureSections.forEach((section) => {
        const sectionTopAligned =
          section.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset - 1;

        if (
          scrollPosition >= sectionTopAligned &&
          sectionTopAligned > closestTop
        ) {
          closestTop = sectionTopAligned;
          activeSection = section;
        }
      });

      if (activeSection) {
        const sectionId = activeSection.getAttribute("id");

        featuresTabs.forEach((tab) => {
          tab.classList.remove("selected");

          if (tab.dataset.featuresId === sectionId) {
            tab.classList.add("selected");
          }
        });
      }
    };

    featuresTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        featuresTabs.forEach((item) => {
          item.classList.remove("selected");
        });
        tab.classList.add("selected");

        const targetId = tab.dataset.featuresId;
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          const targetPosition =
            targetSection.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
        }
      });
    });

    window.addEventListener("scroll", updateActiveTab);
    updateActiveTab();
  }

  initFeaturesSlider({ carousel, prevBtn, nextBtn }) {
    if (!carousel) return;

    $(carousel).slick({
      infinite: true,
      speed: 350,
      slidesToScroll: 1,
      arrows: true,
      variableWidth: true,
      prevArrow: $(prevBtn || null),
      nextArrow: $(nextBtn || null),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          },
        },
      ],
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new SellMorePage().init();
});
